module.exports = __webpack_public_path__ + "static/media/expressjs.b62fd807.png";